// extracted by mini-css-extract-plugin
module.exports = {"searchContainer":"styles_searchContainer__Klfqj","searchInput":"styles_searchInput__gVzKF","searchLogo":"styles_searchLogo__hr3_U"};